import { SvgIconBase, } from "./Base";


export const Light = ({
	fill = "currentColor",
	scale = 1,
}: { fill?: string; scale?: number; }) => {
	return (
		<SvgIconBase width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Light Mode" scale={scale}>
			<title>Light Mode</title>
			{/* Sun center circle */}
			<circle cx="12" cy="12" r="5" fill={fill} />
			{/* Sun rays */}
			<line x1="12" y1="1" x2="12" y2="3" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="12" y1="21" x2="12" y2="23" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="1" y1="12" x2="3" y2="12" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="21" y1="12" x2="23" y2="12" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="4.22" y1="19.78" x2="5.64" y2="18.36" stroke={fill} strokeWidth="2" strokeLinecap="round" />
			<line x1="18.36" y1="5.64" x2="19.78" y2="4.22" stroke={fill} strokeWidth="2" strokeLinecap="round" />
		</SvgIconBase>
	);
};

